__turbopack_context__.v({
  "arrow": "colour-worlds-module__euheSG__arrow",
  "arrowGlass": "colour-worlds-module__euheSG__arrowGlass",
  "badge": "colour-worlds-module__euheSG__badge",
  "bar": "colour-worlds-module__euheSG__bar",
  "barChips": "colour-worlds-module__euheSG__barChips",
  "barChipsOn": "colour-worlds-module__euheSG__barChipsOn",
  "barGlass": "colour-worlds-module__euheSG__barGlass",
  "barLight": "colour-worlds-module__euheSG__barLight",
  "barRow": "colour-worlds-module__euheSG__barRow",
  "btnLine": "colour-worlds-module__euheSG__btnLine",
  "btnWhite": "colour-worlds-module__euheSG__btnWhite",
  "buds": "colour-worlds-module__euheSG__buds",
  "card": "colour-worlds-module__euheSG__card",
  "cardGlass": "colour-worlds-module__euheSG__cardGlass",
  "cardImg": "colour-worlds-module__euheSG__cardImg",
  "cardName": "colour-worlds-module__euheSG__cardName",
  "cardPrice": "colour-worlds-module__euheSG__cardPrice",
  "cardSolid": "colour-worlds-module__euheSG__cardSolid",
  "cardStage": "colour-worlds-module__euheSG__cardStage",
  "charge": "colour-worlds-module__euheSG__charge",
  "chargeCopy": "colour-worlds-module__euheSG__chargeCopy",
  "chargePhoto": "colour-worlds-module__euheSG__chargePhoto",
  "chargeTitle": "colour-worlds-module__euheSG__chargeTitle",
  "chip": "colour-worlds-module__euheSG__chip",
  "chipOn": "colour-worlds-module__euheSG__chipOn",
  "chips": "colour-worlds-module__euheSG__chips",
  "copyArea": "colour-worlds-module__euheSG__copyArea",
  "create": "colour-worlds-module__euheSG__create",
  "createCard": "colour-worlds-module__euheSG__createCard",
  "cwBreathe": "colour-worlds-module__euheSG__cwBreathe",
  "cwFadeUp": "colour-worlds-module__euheSG__cwFadeUp",
  "cwGlowIn": "colour-worlds-module__euheSG__cwGlowIn",
  "cwRiseIn": "colour-worlds-module__euheSG__cwRiseIn",
  "cwWordIn": "colour-worlds-module__euheSG__cwWordIn",
  "darkPill": "colour-worlds-module__euheSG__darkPill",
  "dropped": "colour-worlds-module__euheSG__dropped",
  "eyebrow": "colour-worlds-module__euheSG__eyebrow",
  "fadeBottom": "colour-worlds-module__euheSG__fadeBottom",
  "fadeTop": "colour-worlds-module__euheSG__fadeTop",
  "flip": "colour-worlds-module__euheSG__flip",
  "from": "colour-worlds-module__euheSG__from",
  "gameCard": "colour-worlds-module__euheSG__gameCard",
  "gameIcon": "colour-worlds-module__euheSG__gameIcon",
  "gameLine": "colour-worlds-module__euheSG__gameLine",
  "gameName": "colour-worlds-module__euheSG__gameName",
  "gamePlay": "colour-worlds-module__euheSG__gamePlay",
  "gameTag": "colour-worlds-module__euheSG__gameTag",
  "gameTop": "colour-worlds-module__euheSG__gameTop",
  "giant": "colour-worlds-module__euheSG__giant",
  "glassBtn": "colour-worlds-module__euheSG__glassBtn",
  "glow": "colour-worlds-module__euheSG__glow",
  "head": "colour-worlds-module__euheSG__head",
  "header": "colour-worlds-module__euheSG__header",
  "headerSpace": "colour-worlds-module__euheSG__headerSpace",
  "hero": "colour-worlds-module__euheSG__hero",
  "heroGlow": "colour-worlds-module__euheSG__heroGlow",
  "inner": "colour-worlds-module__euheSG__inner",
  "live": "colour-worlds-module__euheSG__live",
  "logo": "colour-worlds-module__euheSG__logo",
  "logoText": "colour-worlds-module__euheSG__logoText",
  "loud": "colour-worlds-module__euheSG__loud",
  "page": "colour-worlds-module__euheSG__page",
  "panel": "colour-worlds-module__euheSG__panel",
  "panelActions": "colour-worlds-module__euheSG__panelActions",
  "panelLine": "colour-worlds-module__euheSG__panelLine",
  "panelTitle": "colour-worlds-module__euheSG__panelTitle",
  "photo": "colour-worlds-module__euheSG__photo",
  "photoArea": "colour-worlds-module__euheSG__photoArea",
  "play": "colour-worlds-module__euheSG__play",
  "power": "colour-worlds-module__euheSG__power",
  "premium": "colour-worlds-module__euheSG__premium",
  "rail": "colour-worlds-module__euheSG__rail",
  "runner": "colour-worlds-module__euheSG__runner",
  "runnerActions": "colour-worlds-module__euheSG__runnerActions",
  "runnerSub": "colour-worlds-module__euheSG__runnerSub",
  "runnerTitle": "colour-worlds-module__euheSG__runnerTitle",
  "sheen": "colour-worlds-module__euheSG__sheen",
  "shopNow": "colour-worlds-module__euheSG__shopNow",
  "shopPill": "colour-worlds-module__euheSG__shopPill",
  "srOnly": "colour-worlds-module__euheSG__srOnly",
  "stageLine": "colour-worlds-module__euheSG__stageLine",
  "straps": "colour-worlds-module__euheSG__straps",
  "strapsText": "colour-worlds-module__euheSG__strapsText",
  "sub": "colour-worlds-module__euheSG__sub",
  "swatch": "colour-worlds-module__euheSG__swatch",
  "swatches": "colour-worlds-module__euheSG__swatches",
  "tagline": "colour-worlds-module__euheSG__tagline",
  "taglineText": "colour-worlds-module__euheSG__taglineText",
  "textLink": "colour-worlds-module__euheSG__textLink",
  "tile": "colour-worlds-module__euheSG__tile",
  "tiles": "colour-worlds-module__euheSG__tiles",
  "title": "colour-worlds-module__euheSG__title",
  "tools": "colour-worlds-module__euheSG__tools",
  "visit": "colour-worlds-module__euheSG__visit",
  "w": "colour-worlds-module__euheSG__w",
  "world": "colour-worlds-module__euheSG__world",
});
